import keyBy from 'lodash/keyBy';
import { fromJS } from 'immutable';
import { ADD_SHARED_BANKS, REMOVE_SHARED_BANK, UPDATE_SHARED_BANK_PERMISSION } from '@instructure/quiz-common';
var addShareBanks = function addShareBanks(state, sharedBank) {
  return state.mergeDeep(fromJS(keyBy(sharedBank, 'id')));
};
var updateSharedBankPermission = function updateSharedBankPermission(state, _ref) {
  var sharedBankId = _ref.sharedBankId,
    permission = _ref.permission;
  return state.setIn([sharedBankId, 'permission'], permission);
};
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : fromJS({});
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD_SHARED_BANKS:
      return addShareBanks(state, action.payload);
    case UPDATE_SHARED_BANK_PERMISSION:
      return updateSharedBankPermission(state, action.payload);
    case REMOVE_SHARED_BANK:
      return state.remove(action.payload);
    default:
      return state;
  }
});